import React from "react";

function TermsAndConditions() {
  return (
    <body className="mt-3">
      <h2>POLÍTICA DE CONFIDENCIALIDAD</h2>

      <p>
        Nuestra web de Tensolite S.A. (en adelante, WEB) de
        <a href="https://tensolite.com/"> https://tensolite.com/</a>, opera
        sobre un sistema protegido que le garantiza confidencialidad y
        seguridad. Es voluntad de la WEB hacer conocer a los usuarios nuestra
        preocupación por mantener la privacidad de la información que nos
        provean a través de la WEB y utilizarla exclusivamente de la manera que
        los mismos desearían que lo hiciéramos.
      </p>

      <p>
        La utilización de la WEB y sus servicios está dirigida a profesionales
        de la construcción que prestan servicios para terceros, que autorizan el
        uso de sus datos a los fines de promociones comerciales, actualización
        de información comercial y/o cualquier acción de marketing directo por
        mail.
      </p>

      <p>Nuestro compromiso, entonces, es el siguiente:</p>

      <ol>
        <li>
          Limitar la obtención, utilización y revelación de la información de
          los usuarios al mínimo requerido para brindar los servicios previstos
          en nuestra WEB a los usuarios.
        </li>

        <li>
          Permitir que sólo aquellos empleados autorizados de la WEB debidamente
          entrenados en el manejo adecuado de la información de los usuarios
          pueda tener acceso a la misma.
        </li>

        <li>
          No revelar información respecto de los usuarios a entes públicos o
          privados con un objeto distinto a desarrollar la actividad habitual de
          la WEB, a menos que el usuario hubiera sido informado previamente de
          tal circunstancia y que este lo autorice, o que así nos fuera exigido
          por la legislación aplicable.
        </li>

        <li>
          Mantener en todo momento el control sobre la información de los
          usuarios.
        </li>

        <li>
          Comunicaremos a los usuarios, al iniciar nuestros servicios, los
          mecanismos mediante los cuales pueden eliminar sus nombres de las
          listas propias de la WEB, mantenidas con fines de marketing. Los
          usuarios podrán contactarnos en todo momento a los efectos de eliminar
          sus nombres de dichas listas.
        </li>

        <li>
          Cada vez que un usuario visita{" "}
          <a href="https://tensolite.com/">https://tensolite.com/</a>,
          recolectamos cierta información que nos permite mejorar la experiencia
          de navegación en el sitio. Recolectamos el dominio del usuario, el
          último sitio visitado, el navegador y sistema operativo que utiliza.
          También recolectamos y analizamos la actividad de los usuarios en el
          sitio (por ejemplo, cuáles son las páginas más visitadas, el tiempo de
          navegación, etc.). En tal caso, podemos incorporar datos sobre usted
          en las estadísticas agrupadas de nuestros visitantes, y ocasionalmente
          podemos compartir esta información de manera agregada con
          auspiciantes. No obstante, WEB no revelará su identidad o sus datos
          personales sin su permiso. La información que obtenemos de nuestros
          usuarios nos permite mejorar la calidad de nuestros productos y
          servicios, y le permitirá a nuestros anunciantes dirigir con mayor
          efectividad los avisos.
        </li>

        <li>
          Uso de cookies: Un cookie es un pequeño archivo que su navegador
          guarda en el disco rígido. Nuestros cookies no contienen ninguna
          información personal identificable, pero nos permiten ofrecer
          determinadas funcionalidades que facilitan la navegación. Por ejemplo,
          usamos cookies para almacenar su clave y sus preferencias para que no
          tenga que re-ingresarlas la próxima vez que nos visite, además de
          poder ofrecerle un servicio personalizado. Un cookie no puede leer
          información de su disco rígido o archivos creados por otros sitios. La
          mayoría de los navegadores aceptan automáticamente cookies, pero usted
          puede evitarlo modificando las opciones de su navegador. Aún sin
          cookies, usted podrá disfrutar sin problemas la mayoría de los
          servicios y productos de{" "}
          <a href="https://tensolite.com/">https://tensolite.com/</a>.
        </li>
      </ol>

      <p>
        Para cualquier consulta sobre nuestra política de confidencialidad,
        escríbanos a
        <a href="mailto:comunicaciones@tensolite.com">
          {" "}
          comunicaciones@tensolite.com
        </a>
        . Esta dirección electrónica está protegida contra spambots. Es
        necesario activar Javascript para visualizarla.
      </p>

      <h3>
        TÉRMINOS Y CONDICIONES PARA EL ACCESO Y UTILIZACIÓN DE LA WEB TENSOLITE
        SA
      </h3>

      <p>
        Esta página contiene los términos y condiciones que regulan el acceso y
        la utilización de la WEB (
        <a href="https://tensolite.com/">https://tensolite.com/</a>) y sus
        servicios. Por favor, lea esta página con atención. Estos términos y
        condiciones constituyen un acuerdo válido y obligatorio entre usted y la
        WEB. La utilización de la WEB implica la aceptación de estos términos y
        condiciones. Si usted no acepta estos términos y condiciones, no puede
        ni debe utilizar dicho Sitio. WEB podrá revisar y modificar los Términos
        y Condiciones en cualquier momento actualizando la presente página.
        Estos cambios serán obligatorios para usted por lo que le sugerimos que
        de tiempo en tiempo relea estos Términos y Condiciones. Cualquier
        utilización de la WEB o de sus servicios será considerada una aceptación
        de su parte a los Términos y Condiciones vigentes.
      </p>

      <p>
        En caso de encontrar en cualquier momento estos Términos y Condiciones
        inaceptables, no deberá utilizar la WEB en adelante. Salvo expresa
        disposición en contrario, el uso de la WEB y sus servicios está abierto
        al público en forma gratuita e irrestricta. Sin embargo, la WEB se
        reserva el derecho a suspender el uso de este Portal a cualquier
        individuo, a su sola discreción en cualquier momento y por cualquier
        motivo, incluyendo, sin limitación, el incumplimiento de los presentes
        Términos y Condiciones.
      </p>

      <p>
        Cualquier pregunta relacionada con la utilización de la WEB y sus
        servicios debe ser dirigida a{" "}
        <a href="mailto:comunicaciones@tensolite.com">
          comunicaciones@tensolite.com
        </a>
        , esta dirección electrónica está protegida contra spambots. Es
        necesario activar Javascript para visualizarla.
      </p>

      <h3>
        Los Términos y condiciones para el acceso y utilización de la WEB de
        Tensolite S.A. (
        <a href="https://tensolite.com/">https://tensolite.com/</a>), son los
        siguientes:
      </h3>

      <ol>
        <li>Propiedad Intelectual.</li>
        <li>Utilización de la WEB.</li>
        <li>Exoneración y limitación de la responsabilidad de la WEB.</li>
        <li>Generalidades sobre el funcionamiento de la WEB.</li>
        <li>Indemnidad.</li>
        <li>Ley aplicable y jurisdicción.</li>
      </ol>

      <h3>I. Propiedad Intelectual</h3>

      <p>
        El contenido de la WEB, que incluye textos, gráficos, diseños, software
        y programación utilizados y/o exhibidos en la WEB (el "Contenido"), es
        exclusiva propiedad de la WEB y se encuentra protegido por normas
        locales y tratados internacionales.
      </p>

      <p>
        Los usuarios de nuestra WEB se comprometen a no reproducir, modificar,
        exhibir, vender, o distribuir el Contenido, ni a usarlo de cualquier
        otro modo con objeto comercial o público. Esta prohibición incluye la
        copia y adaptación del código HTML utilizado para generar sitios web en
        la WEB. Su logo y ciertos otros nombres o logos son marcas registradas
        de la WEB, encontrando su uso en todo el territorio de la República
        Argentina concedido en forma exclusiva a WEB.
      </p>

      <p>
        Todos los productos relacionados, diseños, marcas y slogans son
        propiedad de la WEB. Asimismo, el estilo y presentación de la WEB
        (incluyendo las combinaciones de colores, forma de los botones, diseño y
        todo otro elemento gráfico) también se encuentran legalmente protegidos.
      </p>

      <h3>II. Utilización de la WEB Tensolite S.A</h3>

      <p>
        <strong>2.1 Generalidades.</strong>
      </p>

      <p>
        La utilización de la WEB y sus servicios está dirigida a profesionales
        de la construcción que prestan servicios para terceros, que autorizan el
        uso de sus datos a los fines de promociones comerciales, actualización
        de información comercial y/o cualquier acción de marketing directo por
        mail.
      </p>

      <p>
        La WEB sólo puede ser utilizado para objetos lícitos dentro del contexto
        descrito precedentemente.
      </p>

      <p>
        Como condición para la utilización de la WEB, el usuario asevera y
        garantiza que no utilizará (o planeará, o incitará o ayudará a terceros
        a utilizar) la WEB con cualquier objetivo o de cualquier manera
        prohibida por estos Términos y Condiciones o por la legislación
        aplicable. Es su responsabilidad asegurar que su utilización de la WEB
        cumpla con estos Términos y Condiciones y demás legislación aplicable.
      </p>

      <p>
        <strong>2.2 Reglas.</strong>
      </p>

      <p>
        En particular, la aceptación de estos Términos y Condiciones implica su
        aceptación de las siguientes reglas:
      </p>

      <p>
        <strong>A. Reglas para Colocación:</strong>
      </p>

      <ol>
        <li>
          Toda información que el usuario provea o suministre a nuestra WEB (la
          "Información") no podrá contener:
        </li>
        <ul>
          <li>a) URLs o enlaces a Sitios Web.</li>
          <li>b) Material protegido por derecho de autor.</li>
          <li>
            c) Material que infrinja cualquier otro derecho de propiedad
            intelectual, o los derechos de privacidad de terceros.
          </li>
          <li>
            d) Cualquier material sexualmente explícito, obsceno, calumnioso,
            difamatorio o injurioso.
          </li>
          <li>e) Cualquier material ofensivo para terceros.</li>
          <li>f) Datos falsos o inexactos.</li>
        </ul>
        <li>Usted no podrá utilizar la Información para:</li>
        <ul>
          <li>a) Asumir una falsa identidad.</li>
          <li>b) Colocar información falsa, imprecisa o engañosa.</li>
          <li>c) Colocar cartas en cadena o estructuras piramidales.</li>
          <li>
            d) Colocar opiniones o avisos, comerciales o de cualquier otra
            naturaleza.
          </li>
        </ul>
      </ol>

      <p>
        <strong>B. Reglas de Conducta:</strong>
      </p>

      <ol>
        <li>
          El usuario no podrá responder a colocaciones de otros usuarios de
          ninguna manera o por ningún motivo distinto del esperado.
        </li>
        <li>
          Los usuarios no podrán remitir correo electrónico de naturaleza
          comercial no solicitado a otros usuarios de la WEB.
        </li>
        <li>
          El usuario no podrá revisar, modificar o eliminar cualquier material
          colocado por terceras personas en la WEB (
          <a href="https://tensolite.com/">https://tensolite.com/</a>).
        </li>
        <li>
          WEB no está obligado a monitorear la conducta de sus usuarios, pero
          puede investigar cuando se reporten violaciones. A los usuarios que
          violen estas Reglas de Conducta se les podrá negar el acceso a la WEB.
        </li>
      </ol>

      <p>
        <strong>C. Reglas de Seguridad:</strong>
      </p>

      <p>
        Los usuarios tienen prohibido violar o intentar violar la seguridad de
        la WEB , incluyendo, sin limitación:
      </p>

      <ol>
        <li>
          Acceso a datos no provistos para tal usuario o acceso a un servidor o
          cuenta a la que el usuario no se encuentra autorizado a acceder.
        </li>
        <li>
          Probar o testear la vulnerabilidad de un sistema o red o violar
          medidas de seguridad o autenticación sin la debida autorización.
        </li>
        <li>
          Interferir con el servicio con cualquier usuario, incluyendo, sin
          limitación, la remisión de virus al Sitio Web, sobrecargando o
          mediante "mailbombing" o "crashing".
        </li>
        <li>
          Enviar correo electrónico no solicitado, incluyendo promociones y/o
          publicidad de productos o servicios.
        </li>
      </ol>

      <p>
        La violación de estas Reglas de Seguridad puede generar responsabilidad
        de naturaleza penal y/o civil. WEB podrá investigar los hechos que
        puedan comprender dichas violaciones y cooperar con las autoridades en
        las acciones que se inicien contra los usuarios involucrados en dichas
        violaciones.
      </p>

      <h3>III. Exoneración y limitación a la responsabilidad de la WEB:</h3>

      <p>
        <strong>
          3.1 El Contenido de nuestra WEB no efectúa ninguna aseveración o
          garantía en relación al Contenido de la WEB, incluyendo, pero no
          limitado a, enlaces defectuosos, inexactitudes o errores tipográficos.
        </strong>
      </p>

      <p>
        WEB no asevera ni garantiza la veracidad, exactitud o confiabilidad de
        la WEB o de su Contenido. Al aceptar estos Términos y Condiciones, los
        usuarios aceptan utilizar la WEB a su propio riesgo.
      </p>

      <p>
        <strong>3.2 Análisis y opiniones contenidas en la WEB.</strong>
      </p>

      <p>
        WEB no asevera ni garantiza la veracidad, exactitud o confiabilidad de
        las informaciones u opiniones incluidas en nuestra WEB ni en ningún Link
        que aparezca en nuestra WEB. Sin perjuicio de que consideramos que la
        información a la que usuario tenga acceso a través de nuestra WEB ha
        sido obtenida de medios que consideramos confiables, WEB no asume
        responsabilidad alguna y no otorga ninguna garantía acerca de la
        veracidad, actualidad, exactitud y/o confiabilidad de la misma.
      </p>

      <p>
        WEB no será responsable de ninguna decisión financiera que el usuario
        realice luego de su visita a nuestra WEB. La información contenida en el
        sitio no implica ningún tipo de opinión sobre la seguridad o calidad en
        el manejo de las inversiones ni sobre los rendimientos en el futuro. Las
        opiniones, análisis y/o información de nuestra WEB es proveída a
        nuestros usuarios con el único fin de colaborar con los mismos a tomar
        sus propias decisiones y no pueden ser consideradas como recomendaciones
        de comprar, vender o realizar cualquier otra negociación y/u operación
        en particular.
      </p>

      <p>
        WEB no se responsabiliza por la mala interpretación de lo expuesto en la
        WEB o de su uso indebido, ni de perjuicios invocados por quienes fueran
        a tomar decisiones de acuerdo con la información exhibida en nuestra WEB
        o sus servicios. Tampoco garantiza ni se adhiere a la información y
        opiniones vertidas en los destinos listados en la WEB
      </p>

      <h3>IV. Generalidades sobre el funcionamiento de la WEB:</h3>

      <p>
        El usuario asume toda la responsabilidad y el riesgo derivado de la
        utilización de esta WEB y la Internet en general. La WEB y su contenido
        son provistos sin garantías de ningún tipo, ya sea expresa o implícita.
      </p>

      <p>
        No se garantiza que la WEB funcionará permanentemente de la manera
        esperada y/o sin interrupciones, errores, defectos o imprecisiones.
      </p>

      <p>
        No se garantiza que la WEB opere libre de errores o que la WEB y sus
        servidores estén libres de virus computacionales u otros mecanismos
        dañosos. Si la utilización de la WEB o de sus materiales resulta en la
        necesidad de reparar o reemplazar equipos o datos, WEB no será
        responsable de dichos costos.
      </p>

      <p>
        WEB no asume ninguna responsabilidad por las actividades o conducta de
        los usuarios. Nada en esta WEB debe ser considerado como un patrocinio o
        garantía en relación a un usuario o terceros, ya sea en relación a sus
        sitios web, productos, servicios, o de cualquier otro modo.
      </p>

      <p>
        En todos los servicios de elaboración de productos de acuerdo a
        indicaciones proporcionadas por usuarios, la elaboración de dichos
        productos será realizada de acuerdo a los datos ingresados por el
        usuario que corresponda, por lo cual la obligación de la WEB se reduce a
        la entrega de los productos solicitados, elaborados de acuerdo a dichos
        datos.
      </p>

      <p>
        WEB no será responsable en caso de que cualquier usuario ingrese datos
        erróneos o inexactos, ni por cualesquiera consecuencias que pudieran
        surgir del uso de productos elaborados en base a dichos datos erróneos o
        inexactos.
      </p>

      <p>
        En ninguna circunstancia WEB o sus anunciantes serán responsables por
        cualquier daño (incluyendo, sin limitación, daño emergente, lucro
        cesante, o daños resultantes de pérdida de datos, o interrupción de
        negocios) resultantes del uso o acceso a, o la imposibilidad de usar o
        acceder a, la WEB y su Contenido y/o cualquier documento.
      </p>

      <p>
        El acceso al Contenido puede no ser legal para ciertas personas o en
        ciertos países. Si usted accede a la WEB, lo hará a su propio riesgo y
        será responsable por cumplir con las leyes aplicables.
      </p>

      <h3>V. Indemnidad:</h3>

      <p>
        Usted se obliga a indemnizar y a no hacer responsable a WEB, a sus
        proveedores o a sus anunciantes y a sus respectivos directores,
        ejecutivos y empleados, de cualquier demanda o reclamación (incluyendo
        honorarios de abogados) que surja de su utilización de la WEB o su
        violación de estos Términos y Condiciones.
      </p>

      <h3>VI. Ley aplicable y jurisdicción:</h3>

      <p>
        Los presentes Términos y Condiciones serán regidos e interpretados de
        acuerdo con las leyes de la República Argentina, en especial con las
        leyes de protección de datos y privacidad.
      </p>

      <p>
        Cualquier controversia relacionada con estos Términos y Condiciones, su
        interpretación y/o ejecución se someterá a la jurisdicción de los
        tribunales ordinarios de la República Argentina, con exclusión de
        cualquier otra jurisdicción.
      </p>

      <p>
        Estos Términos y Condiciones constituyen el acuerdo completo entre WEB y
        el usuario en relación a la utilización de nuestra WEB. Este acuerdo
        reemplaza cualquier acuerdo previo, oral o por escrito, que el usuario
        haya celebrado con WEB.
      </p>

      <p>
        La falta de acción de WEB frente a la violación por el usuario de estos
        Términos y Condiciones no constituirá una renuncia por parte de WEB de
        sus derechos.
      </p>

      <p>
        Si alguna disposición de estos Términos y Condiciones es considerada
        nula o no aplicable, dicha disposición será removida de los Términos y
        Condiciones, y las disposiciones restantes de estos Términos y
        Condiciones mantendrán su plena vigencia.
      </p>

      <p>
        Este acuerdo ha sido celebrado en la Ciudad Autónoma de Buenos Aires,
        República Argentina, en el idioma español.
      </p>
    </body>
  );
}

export default TermsAndConditions;
